jQuery(document).ready(function($) {

  var Headroom = require( 'headroom.js' );

  var body = $('body');

  // Headroom for detecting scroll up / down

  // $( '.site-header' ).clone().insertAfter( $( '.site-header' ) ).addClass( 'floating-header' ).removeClass( 'site-header' );

  // grab an element
  var header = document.querySelector( '.site-header--mobile' ); // pure JS way
  // var header = $( '.site-header' ).get( 0 ); // jQuery way

  // options
  var options = {
      offset : 400,
      tolerance : {
          down : 0,
          up : 10
      },
      classes : {
          // when scrolling up
          pinned : "pinned",
          unpinned : "unpinned",
          top : "top",
          // when below offset
          notTop : "not-top"
      }
  };

  if ( header ) {

    // construct an instance of Headroom, passing the element
    var headroom  = new Headroom( header, options );

    // console.log( headroom );

    // initialize
    headroom.init();

  }

  // Menu toggle

  $('.js-menu-button').click(function() {
    body.toggleClass( 'menu-is-open' ).removeClass( 'search-is-open' );
  });

  $('.js-search-button').click(function() {
    body.toggleClass( 'search-is-open' ).removeClass( 'menu-is-open' );
    if ( body.hasClass( 'search-is-open' ) ) {
      $( '.search-field' ).focus();
    }
  });

  // Close menu on menu background click

  $( '.site-nav, .search-overlay' ).click( function(e) {
    // console.log( $( e.target ).closest( '.header-buttons, a' ), $( e.target ).closest( '.header-buttons, a' ).length );
    if ( ! $( e.target ).closest( '.header-buttons, form' ).length ) { // make sure it was the menu that was clicked and not a child link http://stackoverflow.com/a/9183467
      body.removeClass( 'menu-is-open  search-is-open' );
    }
  } );

}); //jQuery
